import { render, staticRenderFns } from "./pushToYuanshou.vue?vue&type=template&id=c85ab9dc&scoped=true"
import script from "./pushToYuanshou.vue?vue&type=script&lang=js"
export * from "./pushToYuanshou.vue?vue&type=script&lang=js"
import style0 from "./pushToYuanshou.vue?vue&type=style&index=0&id=c85ab9dc&prod&lang=css"
import style1 from "./pushToYuanshou.vue?vue&type=style&index=1&id=c85ab9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ab9dc",
  null
  
)

export default component.exports